// src/apiBase.js
// Prefer env if provided, otherwise default to same-origin '/api'
export const API_BASE =
    process.env.REACT_APP_API_BASE?.trim() || '/api';